import { ReactComponent as Menudots } from "../../../img/icons/menu_dot_icon.svg";
// import { ReactComponent as Trash } from '../../../img/icons/trash_icon.svg';
import { ReactComponent as Trash_Icon } from "../../../img/icons/trash_icon.svg";
import { ReactComponent as Closex } from "../../../img/icons/close_x_icon.svg";
import { ReactComponent as CameraIcon } from "../../../img/icons/camera_icon.svg";
// import { ReactComponent as Arrow_up } from '../../../img/icons/close_x_icon.svg';
import { ReactComponent as Arrow_down } from "../../../img/icons/arrow_down_icon.svg";
import { ReactComponent as PencilIcon } from "../../../img/icons/pencil_icon.svg";
import { ReactComponent as PencilIcon1 } from "../../../img/icons/edit_icon.svg";
import { ReactComponent as EyeIcon } from "../../../img/icons/eye_icon.svg";
import { ReactComponent as GearIcon } from "../../../img/icons/gear_icon.svg";

import { ReactComponent as Arrow_left_Type1 } from "../../../img/icons/arrow_left_type1_icon.svg";
import { ReactComponent as Arrow_left_Type2 } from "../../../img/icons/arrow_left_type2_icon.svg";

import { ReactComponent as CashIcon } from "../../../img/icons/cash-outline.svg";
import { ReactComponent as DeliverIcon } from "../../../img/icons/deliver.svg";
import { ReactComponent as PlusIcon } from "../../../img/icons/add_items_icon.svg";
import { ReactComponent as EnclosedPlusIcon } from "../../../img/icons/enclosed_plus_icon.svg";
import { ReactComponent as TickIcon } from "../../../img/icons/tick_icon.svg";
import { ReactComponent as RefreshIcon } from "../../../img/icons/refresh_icon.svg";
// import { ReactComponent as Arrow_left } from '../../../img/icons/arrow_left_icon.svg';
// import { ReactComponent as Arrow_right } from '../../../img/icons/arrow_right_icon.svg';
import "./imagesStyle.scss";

export const MenuDots = ({ clickhandel }) => (
  <Menudots width="10" onClick={clickhandel} />
);
export const Refresh = ({ clickhandel }) => (
  <RefreshIcon width="20" onClick={clickhandel} />
);
// type
// none = 16 * 17
// sm = 9 * 9
//m = 10 * 10
export const Close = ({ clickhandel, type, white, style }) => (
  <Closex
    width={type == "sm" ? "9" : type == "m" ? "10" : "16"}
    height={type == "sm" ? "9" : type == "m" ? "10" : "16"}
    style={
      style ? { ...style } : { "--svg_current_color": white ? "#fff" : "#000" }
    }
    onClick={clickhandel}
  />
);

export const TrashIconBlack = ({ clickhandel, white, style }) => (
  <Trash_Icon
    style={{
      "--svg_current_color": white ? "#fff" : "#000",
      ...(style ? style : {}),
    }}
    onClick={clickhandel}
  />
);

export const Trash = ({ clickhandel, white, custstyle }) => (
  <Trash_Icon
    height="30px"
    style={{ "--svg_current_color": white ? "#fff" : "#000", ...custstyle }}
    onClick={clickhandel}
  />
);

export const Camera = ({ clickhandel, type, white }) => (
  <CameraIcon
    width={type == "sm" ? "9" : type == "m" ? "10" : "18"}
    height={type == "sm" ? "9" : type == "m" ? "10" : "18"}
    style={{ "--svg_current_color": white ? "#fff" : "#000" }}
    onClick={clickhandel}
  />
);
export const Pencil = ({ clickhandel, type, white, edit, custstyle, style }) =>
  edit ? (
    <PencilIcon1 style={{ ...custstyle }} onClick={clickhandel} />
  ) : (
    <PencilIcon
      width={"18"}
      style={{ "--svg_current_color": white ? "#fff" : "#000" }}
      onClick={clickhandel}
    />
  );
export const Eye = ({ clickhandel, type, white, style, className }) => (
  <EyeIcon
    className={className || ""}
    width={type == "m" ? "25" : "18"}
    height={type == "m" ? 25 * (13 / 18) : "13"}
    style={{ "--svg_current_color": white ? "#fff" : "#000", ...style }}
    onClick={clickhandel}
  />
);
export const Gear = ({ clickhandel, type, white }) => (
  <EyeIcon
    width={"18"}
    style={{ "--svg_current_color": white ? "#fff" : "#000" }}
    onClick={clickhandel}
  />
);
// export const TrashIconWhite = ({ clickhandel }) => <Trash_icon_white onClick={clickhandel} />

// none = 24 * 24
// sm = 14 * 8
export const ArrowDown = ({ clickhandel, type, white, custStyle }) => (
  <Arrow_down
    width={type == "sm" ? 17 : 24}
    height={((type == "sm" ? 17 : 24) / 14) * 8}
    style={{
      "--svg_current_color": white ? "#fff" : "#000",
      overflow: "visible",
      ...custStyle,
    }}
    onClick={clickhandel}
  />
);
export const ArrowLeft = ({ clickhandel, type, white, svg_type }) => {
  if (svg_type == "type1") {
    return (
      <Arrow_left_Type1
        width={type == "sm" ? "16" : "24"}
        style={{
          "--svg_current_color": white ? "#fff" : "#000",
          overflow: "visible",
        }}
        onClick={clickhandel}
      />
    );
  } else if (svg_type == "type2") {
    return (
      <Arrow_left_Type2
        width={type == "sm" ? "12" : "10"}
        style={{
          "--svg_current_color": white ? "#fff" : "#000",
          overflow: "visible",
        }}
        onClick={clickhandel}
      />
    );
  }
};
export const Cash = ({ clickhandel, white, custStyle }) => (
  <CashIcon
    style={{
      "--svg_current_color": white ? "#fff" : "#000",
      overflow: "visible",
      ...custStyle,
    }}
    onClick={clickhandel}
  />
);
export const Deliver = ({ clickhandel, white, custStyle }) => (
  <DeliverIcon
    style={{
      "--svg_current_color": white ? "#fff" : "#000",
      overflow: "visible",
      ...custStyle,
    }}
    onClick={clickhandel}
  />
);
export const Plus = ({ clickhandel, white, custStyle }) => (
  <PlusIcon
    style={{
      "--svg_current_color": white ? "#fff" : "#000",
      overflow: "visible",
      ...custStyle,
    }}
    onClick={clickhandel}
  />
);
export const EnclosedPlus = ({ clickhandel, white, custStyle, type }) => (
  <EnclosedPlusIcon
    width={type == "sm" ? "11" : "22"}
    height={type == "sm" ? "11" : "22"}
    style={{
      "--svg_current_color": white ? "#fff" : "#000",
      overflow: "visible",
      ...custStyle,
    }}
    onClick={clickhandel}
  />
);

// special grade
export const Tick = ({ clickhandel, white, type, color, style }) => (
  <TickIcon
    width={type == "sm" ? 11 : 16}
    height={((type == "sm" ? 11 : 16) / 14) * 12}
    style={{
      "--svg_current_color":
        color == "1"
          ? "#fff"
          : color == "2"
          ? "#000"
          : color == "3"
          ? "var(--green)"
          : color == "4"
          ? "var(--red)"
          : "var(--grey40)",
      overflow: "visible",
      ...style,
    }}
    onClick={clickhandel}
  />
);
export const TickSwitcher = ({ style, state }) => {
  return (
    <div
      className="tick_switcher"
      state={state ? "visible" : "hidden"}
      style={{ ...style }}
    ></div>
  );
};
export const Loading_Icon = ({ style }) => {
  return (
    <svg
      className="loader_icon"
      width={style?.width || "250"}
      // height="320"
      viewBox="0 0 61 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.2512 0.984787C28.794 1.0185 27.8014 1.73394 27.1571 3.02249C26.8765 3.56769 26.5573 4.09219 26.202 4.59197C26.142 4.67813 25.8274 4.68936 25.7038 4.59197C25.6408 4.53493 25.5938 4.46239 25.5675 4.38156C25.5412 4.30073 25.5365 4.21443 25.5539 4.13124C26.0933 3.16108 26.5278 2.07855 27.262 1.27321C28.839 -0.461087 31.6371 -0.419881 33.3189 1.20579C33.7493 1.59238 34.0948 2.06409 34.3334 2.59108C34.5721 3.11806 34.6988 3.68885 34.7055 4.26733C34.7122 4.8458 34.5987 5.41936 34.3723 5.95173C34.1459 6.48409 33.8114 6.96366 33.3901 7.3601C33.024 7.6949 32.6205 7.98649 32.1877 8.22912C31.1839 8.83594 30.6894 9.98589 31.1164 11.0122C31.2971 11.3235 31.5932 11.5509 31.9405 11.6453C33.8958 12.1734 35.1506 13.5182 36.0946 15.185C36.8864 16.5333 37.9801 17.6795 39.2897 18.5338C43.2865 21.2869 47.7364 23.0287 52.3363 24.4821C54.0659 24.9981 55.7518 25.6506 57.3781 26.4336C58.4044 26.9505 59.2697 27.8383 60.0975 28.6811C60.5199 29.1366 60.8134 29.6964 60.9478 30.303C61.0031 30.5344 61.0069 30.775 60.959 31.008C60.9111 31.241 60.8127 31.4607 60.6706 31.6515C60.4234 31.88 59.7304 31.8388 59.3446 31.6515C57.6365 30.9023 55.9734 30.037 54.2878 29.2317C48.1048 26.265 41.9205 23.3021 35.735 20.343C35.1769 20.0733 34.5588 19.9159 34.0194 19.5938C31.6221 18.2266 29.2885 18.4963 26.9024 19.6537C21.2313 22.3919 15.5265 25.0514 9.84415 27.7596C7.19964 29.0219 4.5776 30.3292 1.93682 31.5953C1.44613 31.8313 0.921716 32.1684 0.389816 31.6477C0.161167 31.426 0.0218881 31.1281 -0.00158896 30.8104C-0.025066 30.4928 0.0688945 30.1776 0.26246 29.9247C0.785883 29.0151 1.43675 28.1851 2.19528 27.4599C3.76476 26.089 5.68634 25.3436 7.69033 24.7705C12.1366 23.4894 16.4517 21.89 20.426 19.4665C22.3588 18.2865 24.1006 16.9605 25.2131 14.8779C26.0521 13.3084 27.3444 12.0985 29.1724 11.6827C30.0339 11.4879 30.2774 10.9748 30.1687 10.1844C29.9702 8.73855 30.607 7.90324 31.9255 7.28519C32.6151 6.97216 33.169 6.42145 33.4861 5.7337C33.8031 5.04595 33.8621 4.26708 33.6523 3.53941C33.1953 1.85006 32.0267 0.951075 30.2512 0.984787Z"
        stroke="#000"
        strokeWidth=".7"
        // className=" hanger"
      />
    </svg>
  );
};
export const Receipt = ({ clickhandel }) => {
  return (
    <svg
      onClick={() => clickhandel()}
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      xlink="http://www.w3.org/1999/xlink"
      svgjs="http://svgjs.com/svgjs"
      width="18"
      height="18"
      x="0"
      y="0"
      viewBox="0 0 32 32"
      space="preserve"
    >
      <g>
        <g>
          <path
            d="M16.52 8.55h-8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2zM16.52 13.9h-8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2zM16.52 19.37h-8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2z"
            fill="#000000"
          ></path>
          <path
            d="M25.87 1H6.13a3.9 3.9 0 0 0-3.89 3.92v24.39a1.41 1.41 0 0 0 2.14 1.21l3.68-2.21a.35.35 0 0 1 .37 0l4.09 2.45a1.34 1.34 0 0 0 .72.21 1.46 1.46 0 0 0 .73-.2l4.11-2.46a.35.35 0 0 1 .37 0l3.66 2.21a1.39 1.39 0 0 0 1.42 0 1.41 1.41 0 0 0 .71-1.22V12.44h3.14a2.39 2.39 0 0 0 2.38-2.38V4.92A3.9 3.9 0 0 0 25.87 1zm-3.63 27.26-2.76-1.66a2.38 2.38 0 0 0-2.43 0l-3.8 2.28-3.79-2.29A2.38 2.38 0 0 0 7 26.6l-2.76 1.67V4.92A1.89 1.89 0 0 1 6.13 3h16.52a3.58 3.58 0 0 0-.41 1.63v23.6zm5.52-18.2a.38.38 0 0 1-.38.38h-3.14V4.66A1.63 1.63 0 0 1 25.87 3a1.89 1.89 0 0 1 1.89 1.89z"
            fill="#000000"
          ></path>
        </g>
      </g>
    </svg>
  );
};
export const Setting = () => {
  return <GearIcon />;
};
